<template>
  <div class="wrapper-item bac-white" @click="clickItem">
    <p v-if="item.userName" class="user-name clearfix">{{ item.userName }}</p>
    <div class="custom-item clearfix">
      <img
        :src="
          item.sex === '男'
            ? portraitMale
            : item.sex === '女'
              ? portraitFemale
              : portrait
        "
        class="avatar"
      />
      <div class="custom-item-right">
        <div class="header clearfix">
          <div class="name" style="flex: 1">
            <span class="name-w">{{ item.physician_name }}</span>
            <span v-if="item.ex_data_support" class="tag-yellow">外</span>
            <span v-if="item.is_sync" class="tag-yellow t-update">更</span>
            <span v-if="item.is_wechat">
              <img class="weixin" src="@/assets/svg/weixin.svg" alt="" />
            </span>
            <span v-if="item.territory_id_agent" class="tag-yellow t-white">
              代管{{ item.territory_id_agent }}
            </span>
            <span v-if="item.onsite_is_reserved || item.live_is_reserved" class="tag-checked">
              <Icon style="margin-right: 5px;" name="checked" />已预约
            </span>
            <span v-if="(item.onsite_is_invited || item.live_is_invited) && !item.onsite_is_reserved && !item.live_is_reserved" class="tag-unchecked">
              未预约
            </span>
          </div>
        </div>
        <p class="department">
          {{ item.department_name }} {{ item.professional_title }}
        </p>
        <div class="address">
          <div class="hospital">
            <span class="e-ellipsis-l1">{{ item.institution_name }}</span>
          </div>
        </div>
      </div>
      <div class="fav-hcp">
        <!-- 现场 -->
        <div
          v-if="false && !item.live_is_invited && !item.onsite_is_invited && cityAvailable"
          style="font-size: 24px; margin-left: 20px; color: #fff"
          @click="forwardWechat(onsiteContent)"
        >
          <Icon style="margin-bottom: 5px; background: #aa341b; border-radius: 50%; padding: 6px;" name="share-o" />
          <div style="font-size: 12px; color: #aa341b;">邀请现场<br />{{ cityAvailable }}</div>
        </div>

        <div
          v-if="false && !item.live_is_invited && item.onsite_is_invited && cityAvailable"
          style="font-size: 24px; margin-left: 20px; color: #fff"
          @click="forwardWechat(onsiteContent)"
        >
          <Icon style="margin-bottom: 5px; background: #999; border-radius: 50%; padding: 6px;" name="share-o" />
          <div style="font-size: 12px; color: #999;">重发现场邀请<br />{{ cityAvailable }}</div>
        </div>
        <!-- 直播 -->
        <div
          v-if="status !== 'highlight' && status !== 'finish' && !item.onsite_is_invited && !item.live_is_invited"
          style="font-size: 24px; margin-left: 20px; color: #fff"
          @click="forwardWechat(liveContent)"
        >
          <Icon class="send-icon" :class="{ sent: item.live_is_invited }" name="share-o" />
          <div class="send-label" :class="{ sent: item.live_is_invited }">邀请直播</div>
        </div>
        <div
          v-if="item.live_is_invited && (status === 'upcoming' || status === 'warmup' || !liveWarmupContent && !liveReminderContent && !liveHighlightContent)"
          style="font-size: 24px; margin-left: 10px; color: #fff"
          @click="forwardWechat(liveContent)"
        >
          <Icon class="send-icon" :class="{ sent: item.live_is_invited }" name="share-o" />
          <div class="send-label" :class="{ sent: item.live_is_invited }">重发邀请</div>
        </div>
        <div
          v-if="status === 'warmup' && !item.onsite_is_invited && item.live_is_invited && liveWarmupContent"
          style="font-size: 24px; margin-left: 10px; color: #fff"
          @click="forwardWechat(liveWarmupContent)"
        >
          <Icon class="send-icon" :class="{ sent: item.live_warmup_is_invited }" name="share-o" />
          <div class="send-label" :class="{ sent: item.live_warmup_is_invited }">{{ item.live_warmup_is_invited ? '重发' : '直播' }}预热</div>
        </div>
        <div
          v-if="status === 'reminder' && !item.onsite_is_invited && item.live_is_invited && liveReminderContent"
          style="font-size: 24px; margin-left: 10px; color: #fff"
          @click="forwardWechat(liveReminderContent)"
        >
          <Icon class="send-icon" :class="{ sent: item.live_reminder_is_invited }" name="share-o" />
          <div class="send-label" :class="{ sent: item.live_reminder_is_invited }">{{ item.live_reminder_is_invited ? '重发' : '直播' }}提醒</div>
        </div>
        <div
          v-if="status === 'highlight' && liveHighlightContent"
          style="font-size: 24px; margin-left: 10px; color: #fff"
          @click="forwardWechat(liveHighlightContent)"
        >
          <Icon class="send-icon" :class="{ sent: item.live_highlight_is_invited }" name="share-o" />
          <div class="send-label" :class="{ sent: item.live_highlight_is_invited }">{{ item.live_highlight_is_invited ? '重发' : '直播' }}精粹</div>
        </div>
      </div>
      <div style="position: relative;">
        <div v-if="products.length" class="parting-label">
          <div
            v-for="(productItem, productIndex) in products"
            :key="productIndex"
          >
            <div v-if="productItem.sales_segment" class="parting-label-child">
              <div class="p-relative">
                {{ productItem.sales_segment }}
                <span class="p-abs"> {{ productItem.product_name }} </span>
              </div>
              <!-- <div class="p-hidden">{{ physicianSegment.substring(1, physicianSegment.length) }}</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <slot></slot>
  </div>
</template>
<script>
import beforeFavoriteMixins from '@/mixins/beforeFavoriteMixins';
import {getLocalStorage} from '@/utils';
import {wecomSDK} from '@/utils/wecom';
import {Icon} from 'vant';
export default {
  components: {
    // Button,
    Icon,
  },
  mixins: [beforeFavoriteMixins],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    status: {
      type: String,
      default() {
        return '';
      },
    },
    onsiteContent: {
      type: Object,
      default() {
        return {};
      },
    },
    liveContent: {
      type: Object,
      default() {
        return {};
      },
    },
    liveWarmupContent: {
      type: Object,
      default() {
        return {};
      },
    },
    liveReminderContent: {
      type: Object,
      default() {
        return {};
      },
    },
    liveHighlightContent: {
      type: Object,
      default() {
        return {};
      },
    },
    parting: {
      type: String,
      default() {
        return '';
      },
    },
    physicianSegment: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      portrait: require('@/assets/lundbeck/portrait.png'),
      portraitMale: require('@/assets/lundbeck/portrait-male.png'),
      portraitFemale: require('@/assets/lundbeck/portrait-female.png'),
      cities: [
        '上海',
        '北京',
        '天津',
        '杭州',
        '广州',
        '成都',
        '武汉',
        '沈阳',
        '济南',
        '石家庄',
        '长沙',
        '重庆',
      ]
    };
  },
  computed: {
    isKol() {
      if (
        this.$route.name === 'KolHome' ||
        this.$route.name === 'doctorListHome'
      ) {
        return true;
      } else {
        return false;
      }
    },
    cityAvailable() {
      const city = this.item?.city?.replace('市', '');
      return this.cities.includes(city) ? city + (city === '上海' ? '主' : '分') + '会场' : null;
    },
    products() {
      const products = this.item.products ? JSON.parse(this.item.products) : [];
      return products.sort((a, b) => {
        const segmentA = a.sales_segment ? a.sales_segment.toLowerCase() : '';
        const segmentB = b.sales_segment ? b.sales_segment.toLowerCase() : '';
        if (segmentA < segmentB) {
          return -1;
        }
        if (segmentA > segmentB) {
          return 1;
        }
        return 0;
      });
    },
  },

  methods: {
    clickItem(item) {
      // this.$emit('clickItem', item);
    },
    async forwardWechat(content) {
      this.$emit('clickItem', this.item, content);
      // console.log(content);
      // const toast = this.$createToast({
      //   time: 10000,
      //   mask: false,
      // });
      // toast.show();
      // try {
      //   await wecomSDK.shareWechatMessage({
      //     content_id: content.content_id,
      //     sender_user_id: getLocalStorage('user_id'),
      //     sender_user_name: getLocalStorage('user_name'),
      //     sender_territory_id: getLocalStorage('territory_id'),
      //     receiver_physician_id: this.item.physician_id,
      //     send_time: new Date(),
      //     title: content.content_name,
      //     description: content.description,
      //     wx_logo: content.wx_logo,
      //   });
      // } catch (err) {
      //   this.$toast.fail('转发失败，请稍后重试');
      // }
      // toast.hide();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/var.scss';
.box {
  border-top: none;
}
.custom-item {
  display: flex;
  align-items: flex-start;
  position: relative;
  // background-color: #ffffff;
  padding: 10px 10px 10px 10px;
  // margin-bottom: 10px;
  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .custom-item-right {
    flex: 1;
    font-size: 12px;
    text-align: left;
    padding-left: 10px;
    @include suggest-detail-header();
    .count {
      // float: right;
      font-size: 19px;
      color: #b2b2b2;
      .count-color {
        color: #ab351c;
        min-width: 32px;
      }
    }
    .department {
      padding: 6px 0 4px 0;
    }
    .address {
      color: #b2b2b2;
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      .hospital {
        flex: 1;
        min-width: 0;
        width: 0;
        line-height: 20px;
        span {
          display: block;
        }
      }
      .cube-btn {
        // width: 84px;
        padding: 4px 8px;
        font-size: 11px;
        border-radius: 20px;
      }
    }
  }
}
.wrapper-item {
  border-radius: 10px;
  padding: 6px 0;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 6px;
  &.top {
    border: 1px solid #80d3ae;
    background: #f1f7f5;
  }
  .score-more {
    display: block;
    font-size: 10px;
    transition: transform 0.3s;
    &.selected {
      transform: rotate(180deg);
    }
    .more-icon {
      color: #d9d9d9;
      font-size: 24px;
      font-weight: bold;
    }
  }
}
.title {
  font-size: 14px;
  color: #000;
  text-align: left;
  padding: 10px;
}
::v-deep .cube-popup-content {
  width: 94%;
}
@import '@/styles/card-item-popup.scss';
.badge-icon {
  display: block;
  font-size: 10px;
  line-height: 16px;
}
.btn-follow {
  float: right;
  padding: 2px 13px;
  background-color: #aa341b;
  border-radius: 10px;
  color: #fff;
}
.cube-follow-btn {
  width: initial !important;
  padding: 4px 8px !important;
  font-size: 12px;
  border-radius: 20px;
  & + .cube-follow-btn {
    margin-left: 10px;
  }
  .dimension-icon {
    margin-right: 2px;
  }
}
.Badge-tui {
  ::v-deep {
    .van-badge {
      padding: 2px 8px;
      top: -12px;
      right: -42px;
      -webkit-transform-origin-x: 0;
      transform: scale(0.8);
      // right: initial;
    }
  }
}
.name-suffix {
  display: inline-block;
  margin-left: 4px;
}
.user-name {
  font-size: 15px;
  text-align: left;
  padding: 5px 15px;
}
.parting-label {
  display: flex;
  position: absolute;
  top: -15px;
  right: -10px;
  .parting-label-child {
    padding: 2px 2px;
    background: #c0c0c0;
    border-radius: 0px 5px 0px 5px;
    font-size: 10px;
    font-family: Arial;
    font-weight: 400;
    color: #ffffff;
    max-width: 4rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // & + .parting-label-child {
    //   margin-left: 5px;
    // }
    margin-left: 2px;
  }
}
.tag-yellow {
  padding: 3px 2px 2px 2px;
  color: #ffffff;
  // font-weight: bold;
  // -webkit-transform: skewX(-12deg);
  // transform: skewX(-12deg);
  border-radius: 2px;
  display: inline-block;
  font-size: 10px;
  background-color: #f5b496;
  margin-left: 5px;
  height: 10px;
  &.t-update {
    background-color: #89d329;
  }
  &.t-white {
    color: #000;
    background-color: #ffffff;
  }
}
.tag-checked {
  padding: 4px 10px 2px 6px;
  color: #ffffff;
  // font-weight: bold;
  // -webkit-transform: skewX(-12deg);
  // transform: skewX(-12deg);
  border-radius: 20px;
  display: inline-block;
  font-size: 12px;
  background-color: #aa341b;
  margin-left: 10px;
  height: 14px;
}
.tag-unchecked {
  padding: 5px 8px 1px 8px;
  color: #ffffff;
  // font-weight: bold;
  // -webkit-transform: skewX(-12deg);
  // transform: skewX(-12deg);
  border-radius: 20px;
  display: inline-block;
  font-size: 12px;
  background-color: #ccc;
  margin-left: 10px;
  height: 14px;
}
.p-relative {
  // display: flex;
  // position: relative;
  // width: 60px;
  // text-align: left;
  .p-hidden {
    // visibility: hidden;
    // scale: 0.7;
    display: none;
  }
  .p-abs {
    display: block;
    // vertical-align: sub;
    font-size: 5px;
    // scale: 0.6;
    // position: absolute;
    // bottom: -3px;
    // left: 3px;
  }
}
.weixin {
  width: 16px;
  height: 16px;
  margin-left: 5px;
}
.name-d {
  margin-left: 5px;
}
.fav-hcp {
  // position: absolute;
  // right: 10px;
  // top: 20px;
  margin-top: 15px;
  font-size: 15px;
  color: #aa341b;
  display: flex;
}
.fav-kol {
  margin-top: -10px;
  text-align: right;
  font-size: 22px;
  color: #aa341b;
}
.send-icon {
  margin-bottom: 5px; margin-right: 5px; background: #0cc160; border-radius: 50%; padding: 6px;
  &.sent {
    background: #ccc;
  }
}
.send-label {
  font-size: 10px; color: #0cc160;
  &.sent {
    color: #ccc;
  }
}
</style>
